// THIS HAS TO BE FIRST:
import { polyfill } from "./core/Polyfills";
polyfill();

import { main } from "./pinball/main";
main();
